<template>
    <div class="flexcol-fix">
        <v-alert v-if="error !== null" closable type="error">
            <span><v-icon icon="mdi-alert-outline"/> {{ error }}</span>
        </v-alert>
        <v-container fluid class="text-light">
            <v-row align="center" class="bg-surface-lighten-1 pa-3">
                <v-col cols="auto">
                    <v-btn color="secondary" icon="mdi-play" :disabled="selectedStation === null || playing === true" @click="play"/>
                </v-col>
                <v-col cols="auto">
                    <v-btn color="secondary" icon="mdi-stop" :disabled="selectedStation === null || playing === false" @click="stop"/>
                </v-col>
                <v-col cols="auto" v-show="selectedStation !== null && playing === true">
                    <audio ref="audio" style="display: none" id="kcRadio" :src="currentStreamUrl"/>
                </v-col>                                                      
                <v-col>
                    <v-row class="align-items-center">
                        <v-col class="text-left">
                            <span v-if="selectedStation !== null" class="font-weight-bold"><v-icon icon="mdi-broadcast"/> {{ selectedStation.display_name }}</span>
                            <span v-if="selectedStation === null" class="text-light-darken-3">(kein Sender ausgewählt)</span>
                        </v-col>
                        <v-col cols="auto" class="mr-3">
                            <span v-if="!muted"><v-icon icon="mdi-volume-high"/> {{ volume }}%</span>
                            <span v-if="muted"><v-icon icon="mdi-volume-mute"/> stumm</span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="auto">
                    <v-btn v-if="muted === false" icon="mdi-volume-off" color="secondary" @click="toggleMute" class="mr-2"/>
                    <v-btn v-if="muted === true" icon="mdi-volume-mute" color="secondary" @click="toggleMute"/>
                </v-col>             
                <v-col cols="auto">                
                    <v-btn color="secondary" icon="mdi-volume-minus" @click="changeVolume(-10)"/>
                </v-col>                
                <v-col cols="auto">                    
                    <v-btn color="secondary" icon="mdi-volume-plus" @click="changeVolume(10)"/>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-container fluid class="pa-0">
                        <v-row align="center">
                            <v-col v-if="myStations.length === 0">
                                <v-alert type="info" class="pa-1 text-sm">
                                    <span><v-icon icon="information-outline"/> Sie haben keine Sender in Ihren Favoriten abgelegt.</span>
                                </v-alert>
                            </v-col>
                            <v-col v-for="station in myStations" v-bind:key="station.stream_url" class="bg-surface-lighten-1 pa-2 rounded">
                                <div class="mr-2"><v-icon icon="mdi-broadcast"/> {{ station.display_name }}</div>
                                <div class="text-right">
                                    <v-btn color="secondary" icon="mdi-play" size="small" @click="select(station)"/>
                                    <v-btn color="error" icon="mdi-close" size="small" @click="removeFromMyStations(station)" class="ml-1"/>
                                </div>
                            </v-col>
                        </v-row>                    
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </div>
    <div class="flexcol-fill overflow-hidden bg-surface-lighten-1 ml-4 mr-4 mb-4">
        <v-container fluid>
            <v-row class="bg-surface-lighten-1">
                <v-col class="pa-3">
                    <v-text-field dense hide-details solo-inverted prepend-inner-icon="mdi-magnify" label="Suchen nach weiteren Sendern" v-model="searchQuery" :loading="isSearching" :disabled="isSearching" @blur="search" @keyup.enter="search"/>
                    <v-alert v-if="!isSearching && searchResult !== null && searchResult.length === 0" type="info" class="pa-1 text-sm">
                        <span><v-icon icon="alert-outline"/> Die Suche lieferte keine Ergebnisse.</span>
                    </v-alert>
                    <v-row v-if="!isSearching">
                        <v-col cols="auto" v-for="station in searchResult" v-bind:key="station.stream_url" class="bg-white p-2 border border-dark text-dark rounded text-light small mr-1 mb-1">
                            <span><v-icon icon="broadcast-pin"/> {{ station.display_name }}</span>
                            <v-btn variant="primary" @click="select(station)" class="ml-2"><v-icon icon="play"/></v-btn>
                            <v-btn variant="success" @click="addToMyStations(station)" class="ml-1"><v-icon icon="person-plus"/></v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>            
        </v-container>
    </div>
</template>
<script>
const STORAGE_VAR_RADIOSTATIONS = "kc.radiostations";
const STORAGE_VAR_LASTSTATION= "kc.radiolaststation";
const STORAGE_VAR_RADIOVOLUME = "kc.radiovolume";
import radioBrowser from 'radio-browser';
import kcKeyboard from './keyboard.vue';
export default {
    name: 'kc-radio',
    emits: ['update:modelValue'],
    components: {
        kcKeyboard
    },
    data() {
        return {
            error: null,
            myStations: [],
            isSearching: false,
            searchQuery: null,
            searchResult: null,
            selectedStation: null,
            volume: 80,
            muted: false,
            presetStations: [          
                { 
                    display_name: 'WDR 2',
                    name: 'wdr2',
                    stream_url: 'http://wdr-wdr2-rheinruhr.icecast.wdr.de/wdr/wdr2/rheinruhr/mp3/128/stream.mp3'
                },                                                
                { 
                    display_name: 'Welle NR',
                    name: 'welle_nr',
                    stream_url: 'http://mp3.wellenr.c.nmdn.net/wellenr/livestream.mp3'
                }
            ]
        }
    },
    props: {
        modelValue: null
    },
    mounted() {
        const vm = this;
        vm.playing = false;
        var savedStations = localStorage[STORAGE_VAR_RADIOSTATIONS];
        if (savedStations !== undefined) {
            vm.myStations = JSON.parse(savedStations);
        }
        var lastStation = localStorage[STORAGE_VAR_LASTSTATION];
        if (lastStation !== undefined) {
            vm.selectedStation = JSON.parse(lastStation);
        }
        var initVolume = localStorage[STORAGE_VAR_RADIOVOLUME];
        if (initVolume !== undefined) {
            vm.volume = JSON.parse(initVolume);
        }
        vm.addPresetStations();
    },
    computed: {
        playing: {
            get() {
                const vm = this;
                return vm.modelValue;
            },
            set(v) {
                const vm = this;
                vm.$emit('update:modelValue', v);
            }
        },
        currentStreamUrl() {
            let vm = this;
            if (vm.selectedStation !== null && vm.selectedStation !== undefined) {
                return vm.selectedStation.stream_url
            }
            return '';
        },
        outputVolume() {
            const vm = this;
            if (vm.muted === true) {
                return 0;
            }
            return (vm.volume / 100);
        }
    },
    watch: {
        volume() {
            const vm = this;
            localStorage[STORAGE_VAR_RADIOVOLUME] = JSON.stringify(vm.volume);
        },
        outputVolume() {
            const vm = this;
            vm.setVolume();
        }
    },
    methods: {
        async search() {
            const vm = this;
            
            vm.searchResult = null;
            
            if (vm.searchQuery === null || vm.searchQuery === '') {
                return;
            }
            vm.isSearching = true; 

            let payload = {
                countryCode: "DE",
                name: vm.searchQuery
            };

            try {
                const stations = await radioBrowser.searchStations(payload);
                vm.searchResult = [];
                stations.forEach(s => {
                    vm.searchResult.push(s);
                });                
                vm.isSearching = false;
            } catch(err) {
                vm.error = err;
                vm.isSearching = false;
            }

        },
        select(station) {
            const vm = this;
            vm.selectedStation = station;
            vm.searchQuery = null;
            vm.searchResult = null;
            window.setTimeout(() => {
                vm.play();
            }, 1000);
        },
        addToMyStations(station) {
            const vm = this;
            vm.myStations.push(station);
            localStorage[STORAGE_VAR_RADIOSTATIONS] = JSON.stringify(vm.myStations);
        },
        removeFromMyStations(station) {
            const vm = this;
            var index = vm.myStations.indexOf(station);
            if (index > -1) {
                vm.myStations.splice(index, 1);
                localStorage[STORAGE_VAR_RADIOSTATIONS] = JSON.stringify(vm.myStations);
            }
        },
        play() {
            const vm = this;
            if (vm.selectedStation === null) return;
            localStorage[STORAGE_VAR_LASTSTATION] = JSON.stringify(vm.selectedStation);
            vm.setVolume();   
            vm.$refs.audio.src = vm.selectedStation.stream_url;
            vm.$refs.audio.play();         
            vm.playing = true;            
        },
        stop() {
            const vm = this;
            vm.$refs.audio.src = "";
            vm.playing = false;
        },
        toggleMute() {
            const vm = this;
            vm.muted = !vm.muted;
        },
        setVolume() {
            const vm = this;
            if (vm.$refs.audio !== undefined) {
                vm.$refs.audio.volume = vm.outputVolume;
            }            
        },
        changeVolume(changeValue) {
            const vm = this;
            var newVolume = vm.volume;
            newVolume = newVolume + changeValue;
            if (newVolume < 0 ) newVolume = 0;
            if (newVolume > 100) newVolume = 100;
            vm.volume = newVolume;
        },
        addPresetStations() {
            const vm = this;
            vm.presetStations.forEach(s => {
                var existing = vm.myStations.find(x => x.stream_url === s.stream_url);
                if (existing === undefined) {
                    vm.myStations.push(s);
                }
            });
        }
    }
}
</script>